module.exports = __webpack_public_path__ + "img/143.twice_a_year.e5c790c8.svg";